<script setup>
import {
  ref,
  computed,
  onMounted,
  watch,
} from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';

const { t } = useI18n();
const route = useRoute();

const title = computed(() => t(`common.${route.meta?.title}`));
const tooltip = computed(() => t(`common.tooltip.${route.meta?.tooltip}`));

const showTooltip = ref(false);
let timer = null;

const triggerTooltip = () => {
  // 기존 타이머가 있다면 제거 (중복 방지)
  if (timer) clearTimeout(timer);

  // 툴팁 노출
  showTooltip.value = true;

  // 3초 뒤에 숨김
  timer = setTimeout(() => {
    showTooltip.value = false;
  }, 3000);
};

// 1. 처음 페이지에 들어왔을 때 실행
onMounted(() => {
  if (route.meta?.tooltip) {
    triggerTooltip();
  }
});

// 2. 같은 컴포넌트 내에서 메뉴(경로)만 바뀔 때 실행
watch(() => route.path, () => {
  if (route.meta?.tooltip) {
    triggerTooltip();
  } else {
    showTooltip.value = false;
  }
});

</script>
<template>
  <div class="page-head">
    <div class="page-head__title">
      <h1>{{ title }}</h1>
      <v-tooltip
        v-if="route.meta?.tooltip"
        v-model="showTooltip"
        location="right"
        class="custom__tooltip"
      >
        <template #activator="{ props }">
          <v-icon
            v-bind="props"
            icon="mdi-information"
            class="ml-2"
            size="large"
          />
        </template>
        <span
          style="white-space: pre-line"
        >
          {{ tooltip }}
        </span>
      </v-tooltip>
    </div>
    <ol class="page-head__breadcrumb">
      <!-- <li>
        <span class="page-head__breadcrumb--icon"></span>
        <span class="page-head__breadcrumb--text">홈</span>
      </li>
      <li>
        <span class="page-head__breadcrumb--text">{{ route.name }}</span>
      </li> -->
    </ol>
  </div>
</template>
